import { StyleSheet } from 'aphrodite/no-important';
import { Colors } from 'mm-theme-configuration';
import { baseUnit } from '../../../theming/baseUnitDefinition';

export const createStyles = (colors: Colors, isRecirculationTest = false) => {
  const { primary, lightGrey, black } = colors;
  return StyleSheet.create({
    root: {
      marginTop: baseUnit,
    },
    titleWrapper: {
      marginRight: isRecirculationTest ? '0px' : '-10px',
    },
    sectionDivider: {
      border: `1px solid ${primary}`,
      margin: `10px 0px ${baseUnit}px 0px`,
    },
    articlesWrapper: {
      color: primary,
    },
    articleItem: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',
      color: primary,
    },
    circle: {
      color: primary,
      marginRight: '8px',
    },
    articleWrapper: {
      display: 'flex',
      alignItems: 'center',
    },
    greySectionDivider: {
      borderBottom: `1px solid ${lightGrey}`,
      padding: '10px 0px',
    },
    postWrapperNew: {
      display: 'flex',
      flexDirection: 'row',
      gap: baseUnit,
      alignItems: 'center',
    },
    articleItemNew: {
      width: '-webkit-fill-available',
      margin: 0,
      color: black,
    },
  });
};
